/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  MetaCategorySuggestionControllerSuggestMutationRequest,
  MetaCategorySuggestionControllerSuggestMutationResponse,
  MetaCategorySuggestionControllerSuggestPathParams,
  MetaCategorySuggestionControllerSuggest401,
  MetaCategorySuggestionControllerSuggest404,
} from '../types/MetaCategorySuggestionControllerSuggest.ts';

function getMetaCategorySuggestionSuggestUrl(
  metaCategoryId: MetaCategorySuggestionControllerSuggestPathParams['metaCategoryId'],
) {
  const res = { method: 'POST', url: `/api/user/telegram/category/meta/${metaCategoryId}/suggestions` as const };
  return res;
}

/**
 * {@link /api/user/telegram/category/meta/:metaCategoryId/suggestions}
 */
export async function metaCategorySuggestionSuggest(
  metaCategoryId: MetaCategorySuggestionControllerSuggestPathParams['metaCategoryId'],
  data: MetaCategorySuggestionControllerSuggestMutationRequest,
  config: Partial<RequestConfig<MetaCategorySuggestionControllerSuggestMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    MetaCategorySuggestionControllerSuggestMutationResponse,
    ResponseErrorConfig<MetaCategorySuggestionControllerSuggest401 | MetaCategorySuggestionControllerSuggest404>,
    MetaCategorySuggestionControllerSuggestMutationRequest
  >({
    method: 'POST',
    url: getMetaCategorySuggestionSuggestUrl(metaCategoryId).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
